import { render, staticRenderFns } from "./AppSubTitle.vue?vue&type=template&id=b4127b92&scoped=true&"
import script from "./AppSubTitle.vue?vue&type=script&lang=ts&"
export * from "./AppSubTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AppSubTitle.vue?vue&type=style&index=0&id=b4127b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4127b92",
  null
  
)

export default component.exports